var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"activity-pop pop-video"},[_c('div',{staticClass:"flex-center"},[_c('div',{staticClass:"video-wrap"},[_c('div',{staticClass:"video-close",on:{"click":_vm.closeVideo}},[_vm._v("x")]),_c('video',{staticClass:"video",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }